import { render } from "./SalesTable.vue?vue&type=template&id=05b8dd9f&scoped=true"
import script from "./SalesTable.vue?vue&type=script&lang=js"
export * from "./SalesTable.vue?vue&type=script&lang=js"

import "./SalesTable.vue?vue&type=style&index=0&id=05b8dd9f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b8dd9f"]])

export default __exports__